import type { CollectionsQuery } from '~/generated/graphql';
import { ProductCard } from '../products/ProductCard';

interface CollectionGridProps {
  variants: CollectionsQuery['collections']['items'][number]['productVariants']['items'];
  collectionName: string;
}

export function CollectionGrid({ variants }: CollectionGridProps) {
  if (!variants || variants.length === 0) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 px-4 lg:px-10">
      {variants.map((variant) => (
        <ProductCard
          key={variant.id}
          priceWithTax={{ value: variant.priceWithTax }}
          productName={variant.product.name}
          productVariantId={variant.id}
          productId={variant.product.id}
          description={variant.product.description}
          currencyCode={variant.currencyCode}
          slug={variant.product.slug}
          productAsset={
            variant.featuredAsset ||
            variant.product.featuredAsset ||
            (undefined as any)
          }
        />
      ))}
    </div>
  );
}
